import { createFileRoute } from '@tanstack/react-router';
import { PageShell, Section } from '~/components/layout';
import {
  CtaBanner,
  DownloadQr,
  FaqAccordion,
  FeatureBlock,
  InvestorsGrid,
  RateComparison,
  StepsSection,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import { ButtonLink } from '~/components/ui';
import { compareHero, compareSteps } from '~/content/compare';
import { appDownloadSection, safeSpaceSection } from '~/content/shared';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/compare')({
  head: () =>
    pageHeadMeta({
      title: 'Compare nsave rates with other Alternatives',
      description: 'Compare nsave rates to other providers such as Wise, Payoneer, Xoom, OFX.',
      path: '/compare',
    }),
  component: ComparePage,
});

function ComparePage() {
  return (
    <PageShell>
      <Section className="pt-16 !pb-0 md:pt-24">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-5 text-center md:gap-10">
          <h1 className="text-[40px] leading-[1.1] font-semibold tracking-[-0.03em] text-balance md:text-title-m">
            {compareHero.title}
          </h1>
          <ButtonLink href={compareHero.cta.href} size="md">
            {compareHero.cta.label}
          </ButtonLink>
        </div>
      </Section>

      <RateComparison />

      {/* Extra 40px gap between the comparison table and the steps section. */}
      <div className="pt-10">
        <StepsSection heading="Send easily in 3 steps" steps={compareSteps} />
      </div>

      <FeatureBlock content={appDownloadSection} imagePosition="left" ctaSlot={<DownloadQr />} />
      <InvestorsGrid />
      <TextSection content={safeSpaceSection} sectionClassName="max-md:!my-[40px]" />
      <TestimonialGrid />
      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
